import {
  channelKitchenPath,
  channelRestaurantPath,
  ownBoardChannels,
  type FilterChannel,
} from '@agos/shared'

/**
 * A channel's own *Kuchyňa* and *Otvorené stoly* in the sidebar - `FRONTEND.md` §9.688, owner #24 (O79).
 *
 * **The owner**: *"by pribudla Otvorene stoly OFYR a KUCHYNA OFYR ... a tieto dve sekcie aby vedel aj vypnúť a
 * zapnúť"*. One entry each per channel that has its own boards, placed **directly under** the ordinary one it
 * splits from, so *Kuchyňa Terasa* reads as the terrace's half of *Kuchyňa* rather than as a new screen at the
 * bottom of a section.
 *
 * **Derived from the entry it follows**, so it carries that entry's icon and **guard** - the same permission as
 * the ordinary board, which is what the owner asked for and what the routes enforce (`/kitchen/channel/:slug` is
 * open like `/kitchen`, `/restaurant/channel/:slug` asks `restaurant` like `/restaurant`). A copied guard cannot
 * drift from the one it was copied from.
 *
 * **Switching the flag or the channel off removes the two entries** on the next read of `/sales-channels`, and a
 * channel list that has not arrived adds none: `ownBoardChannels` answers only from loaded rows. The label is the
 * Slovak source with the channel's own name after it, so `SidebarSection` translates it through `<T>` like every
 * other entry.
 */
export const BOARD_PATHS = {
  kitchen: '/kitchen',
  restaurant: '/restaurant',
} as const

export function withChannelBoards<T extends { label: string; path: string }>(
  items: readonly T[],
  channels: readonly FilterChannel[],
): T[] {
  const boards = ownBoardChannels(channels)
  if (boards.length === 0) return [...items]
  return items.flatMap((item) => {
    if (item.path === BOARD_PATHS.kitchen) {
      return [
        item,
        ...boards.map((channel) => ({
          ...item,
          label: `${item.label} ${channel.name}`,
          path: channelKitchenPath(channel.slug),
        })),
      ]
    }
    if (item.path === BOARD_PATHS.restaurant) {
      return [
        item,
        ...boards.map((channel) => ({
          ...item,
          label: `${item.label} ${channel.name}`,
          path: channelRestaurantPath(channel.slug),
        })),
      ]
    }
    return [item]
  })
}
